'use client';

import { useState, useEffect, useRef } from "react";
import styles from "./SecondaryMenuNewLp.module.scss";
import cn from "clsx";

const SecondaryMenuNewLp = ({ SecondayMenuUI }) => {
    const [selectedId, setSelectedId] = useState<string>("");
    const isAutoScrolling = useRef(false);

    const handleLinkClicked = (e, itemText) => {
        isAutoScrolling.current = true;
        const navigationId = itemText.replace(" ", "_");
        setSelectedId(navigationId);
        const el = document.getElementById(navigationId);
        if (!el) return;
        const headerHeight = document.getElementById("header_new")?.offsetHeight || 0;
        const secondarymenuHeight = document.getElementById("secondary_menu_new")?.offsetHeight || 0;
        const yOffset = -(headerHeight + secondarymenuHeight);
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });

        setTimeout(() => {
            isAutoScrolling.current = false;
        }, 700);
    }

    const handleScroll = () => {
    if (isAutoScrolling.current) return;

    const headerHeight =
        document.getElementById("header_new")?.offsetHeight || 0;

    const secondarymenuHeight =
        document.getElementById("secondary_menu_new")?.offsetHeight || 0;

    const triggerPoint = headerHeight + secondarymenuHeight + 20; 

    const navlist = SecondayMenuUI?.map((item) =>
        item?.Label?.replace(" ", "_")
    );

    navlist?.forEach((sec: string) => {
        const section = document.getElementById(sec); 
        const navTab = document.getElementById(`secondary_meny_${sec}`);

        if (!section || !navTab) return;

        const rect = section.getBoundingClientRect();

        if (rect.top <= triggerPoint && rect.bottom > triggerPoint) {
            setSelectedId(sec);

            const offsetLeft = navTab.offsetLeft;
            navTab.parentElement?.scrollTo({
                left: offsetLeft - 40,
                behavior: "smooth",
            });
        }
    });
};

    useEffect(() => {
        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, []);

    return (
        <section
          className={styles.root}
          id="secondary_menu_new"
          data-sticky-tabs
        >
            <div className={styles.container}>
                <ul className={styles.list_wrapper}>
                    {
                        SecondayMenuUI?.map((item) => {
                            const navId = item.Label.replace(" ", "_");
                            return (
                                <li
                                    className={cn(styles.list_item, { [styles.active]: navId === selectedId })}
                                    key={item.id}
                                    onClick={(e) => handleLinkClicked(e, item.Label)}
                                    id={`secondary_meny_${navId}`}
                                >
                                    {item.Label}
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </section>
    )
}

export default SecondaryMenuNewLp;